<div class="flex flex-column bg-landing">
  <div class="flex justify-content-between align-items-center p-4">
    <div class="flex align-items-center gap-3">
      <p-image src="assets/icons/icon-main-logo.svg" alt="main-logo" imageClass="flex" width="40" height="40" />
      <p class="text-color font-semibold hidden sm:block">AIFLOW CRM</p>
    </div>

    <div class="flex gap-3 align-items-center">
      <app-language-config></app-language-config>
      <div
        class="bg-white border-round-xl h-4rem cursor-pointer"
        style="box-shadow: 0px 4px 4px 0px #00000008; padding: 10px 12px"
        (click)="menu.toggle($event)"
        (keyup.enter)="menu.toggle($event)"
        tabindex="0"
      >
        <div class="flex justify-content-between align-items-center gap-2 h-full">
          <div class="flex align-items-center gap-2">
            <p-avatar
              #imgUser
              [image]="userAtt().userImgPath"
              shape="circle"
              styleClass="flex"
              (onImageError)="imgUser['label'] = manageImageEmpty()"
            />
            <div class="w-11rem">
              <p class="line-clamp-2">{{ userAtt().firstName }} {{ userAtt().lastName }}</p>
            </div>
          </div>
          <div class="px-2">
            <i class="pi pi-chevron-down text-xs"></i>
          </div>
        </div>
        <p-tieredMenu #menu [model]="menuItems()" [popup]="true" appendTo="body" class="menu" />
      </div>
    </div>
  </div>
  <div class="flex flex-column gap-6 align-items-center justify-content-center p-4 md:p-5" style="min-height: calc(100vh - 112px)">
    <!-- @if (!companyList()!.length && permissionManage()) { -->
    @if (companyList()!.length) {
      <div class="text-2xl text-color font-semibold">{{ 'choose_company.select_company' | transloco }}</div>
    }
    <div class="flex flex-wrap justify-content-center gap-5">
      @if (companyList()!.length > 0) {
        @for (comp of companyList(); track comp.id) {
          <div class="flex flex-column align-items-center gap-3 w-9rem md:w-12rem">
            <div
              class="w-9rem md:w-12rem h-9rem md:h-12rem border-round-xl cursor-pointer transition-all transition-duration-500 scaled"
              style="box-shadow: 0px 3px 20px 0px #0000000f"
              (click)="onSelectComp(comp)"
              (keyup.enter)="onSelectComp(comp)"
              tabindex="0"
            >
              <p-image
                #imgCompany
                [src]="comp.avatarUrl ? s3BlobPath + comp.avatarUrl : 'assets/images/empty/empty-company.png'"
                alt="company"
                imageClass="object-contain w-full h-full border-round-xl"
                (onImageError)="imgCompany['src'] = 'assets/images/empty/empty-company.png'"
              />
            </div>
            <p class="text-lg text-color font-semibold text-center line-clamp-2 w-full">
              {{ comp.name }}
            </p>
          </div>
        }
      }
      @if (permissionManage()) {
        <div class="flex flex-column align-items-center gap-3" (click)="onSelectComp()" (keyup.enter)="onSelectComp()" tabindex="0">
          <div
            class="flex align-items-center justify-content-center w-9rem md:w-12rem h-9rem md:h-12rem bg-white border-round-xl cursor-pointer transition-all transition-duration-500 scaled"
            style="box-shadow: 0px 3px 20px 0px #0000000f"
          >
            <p-image src="assets/icons/icon-main-logo.svg" alt="main-logo" imageClass="w-5rem md:w-8rem h-5rem md:h-8rem" />
          </div>
          <p class="text-lg text-color font-semibold">{{ 'choose_company.system_management' | transloco }}</p>
        </div>
      }
      @if (!companyList()!.length && !permissionManage()) {
        <div class="flex flex-column align-items-center gap-3">
          <p-image src="assets/images/empty/empty-list-company.png" alt="company-empty" imageClass="w-8rem h-8rem" />
          <p class="text-2xl text-color font-semibold">{{ 'choose_company.comp_not_found_header' | transloco }}</p>
          <div class="flex flex-column gap-1 text-xs text-bluegray-500 font-normal text-center mx-0 md:mx-4">
            <p>{{ 'choose_company.comp_not_found_title1' | transloco }}</p>
            <p>{{ 'choose_company.comp_not_found_title2' | transloco }}</p>
          </div>
        </div>
      }
    </div>
  </div>
</div>
